import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import uuidv4 from "uuid/v4";

import { userSelectors } from "../../nav/selectors";
import Tooltip from "../../shared/components/Tooltip";
import { policies } from "../actions";
import { EntityShape, PolicyShape, ResourceShape } from "../proptypes";
import selectors from "../selectors";

class PoliciesTableItem extends Component {
  state = { checked: false };

  static getDerivedStateFromProps(props) {
    if (props.policy && !props.policy.requiresDelete) {
      return { checked: true };
    }
    return { checked: false };
  }

  createPolicy = () => {
    const { entity, roleUri, currentResource } = this.props;
    const { $uri, type } = entity;
    const policy = { id: uuidv4() };

    policy.resource = currentResource && { $ref: currentResource.$uri };
    policy.role = { $ref: roleUri };
    policy[type] = { $ref: $uri };

    return policy;
  };

  updatePolicy = e => {
    const {
      markForDelete,
      markClean,
      addPolicy,
      removePolicy,
      policy
    } = this.props;
    const { checked } = e.target;

    if (checked) {
      if (policy && policy.requiresDelete) {
        markClean(policy);
      } else {
        const newPolicy = this.createPolicy();
        addPolicy(newPolicy);
      }
    } else if (!checked) {
      if (policy && policy.$uri) {
        markForDelete(policy);
      } else {
        removePolicy(policy);
      }
    }

    this.setState({ checked });
  };

  render() {
    const { checked, policyId } = this.state;
    const { currentResource, policy, canEditPolicies, saving } = this.props;

    let checkboxClass = "p-checkbox__box";
    if (policy && policy.requiresDelete) {
      checkboxClass += " remove-policy";
    } else if (policy && policy.requiresUpdate) {
      checkboxClass += " add-policy";
    }

    const checkbox = (
      <label className="p-checkbox" htmlFor={policyId}>
        <input
          id={policyId}
          className="p-checkbox__input"
          type="checkbox"
          onChange={this.updatePolicy}
          checked={checked}
          disabled={!currentResource || !canEditPolicies || saving}
        />
        <span className={checkboxClass} />
        <span className="u-off-screen">{policyId}</span>
      </label>
    );

    return (
      <div>
        {!currentResource || !canEditPolicies ? (
          <Tooltip
            message={
              !currentResource
                ? "Please select a scope"
                : "You do not have permission to edit policies"
            }
            position="top-center"
          >
            {checkbox}
          </Tooltip>
        ) : (
          checkbox
        )}
      </div>
    );
  }
}

PoliciesTableItem.propTypes = {
  policy: PolicyShape,
  roleUri: PropTypes.string.isRequired,
  addPolicy: PropTypes.func.isRequired,
  markForDelete: PropTypes.func.isRequired,
  markClean: PropTypes.func.isRequired,
  removePolicy: PropTypes.func.isRequired,
  entity: EntityShape.isRequired,
  currentResource: ResourceShape,
  canEditPolicies: PropTypes.bool.isRequired,
  saving: PropTypes.bool.isRequired
};

PoliciesTableItem.defaultProps = {
  currentResource: undefined,
  policy: undefined
};

const mapStateToProps = state => ({
  currentResource: selectors.resources.getCurrent(state),
  canEditPolicies: userSelectors.canEditPolicies(state),
  saving: state.policies.saving
});

const mapDispatchToProps = {
  addPolicy: policies.add,
  removePolicy: policies.removeDirty,
  markForDelete: policies.markForDelete,
  markClean: policies.markClean
};

export { PoliciesTableItem as PoliciesTableItemComponent };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PoliciesTableItem);
